import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import InputField from "../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import {
  getDepartment,
  getDoctors,
} from "../services/EMRServices/emrServices";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";

const durationChips = [
  "No Followup",
  "1 Day",
  "2 Days",
  "3 Days",
  "4 Days",
  "5 Days",
  "6 Days",
  "1 Weeks",
  "3 Weeks",
  "10 Days",
  "15 Days",
  "1 Month",
  "2 Months",
  "3 Months",
  "6 Months",
  "8 Months",
  "1 Year",
  "2 Years",
];

export default function NextFollowUp(props) {
  const {
    departmentOption,
    doctorOption,
    setDepartmentOption,
    setDoctorOption,
    patientData,
  } = props;
  const [selectedChips, setSelectedChips] = useState([]);
  const [nextFollowupDate, setNextFollowupDate] = useState(null);
  const [departmentValue, setDepartmentValue] = useState(null);

  let defaultValues = {
    allergyType: null,
    allergyDescription: "",
  };

  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({});
  let userRole = JSON.parse(localStorage.getItem("loggedUser"));
  const handlechange = (e) => {
    if (e?.length > 0) {
      getDepartment(userRole.loginUnitId, e).then((response) => {
        setDepartmentOption(response.data.result);
      });
    }
  };

  let department = watch("department");

  const handlechangeDoctor = (e) => {
    if (departmentValue?.id > 0) {
      getDoctors(departmentValue?.id, e).then((response) => {
        setDoctorOption(response.data.result);
      });
    }
  };
  const onSubmit = () => {};

  useEffect(() => {
    if (selectedChips?.length > 0) {
      const selectedDuration = selectedChips[0];
      const durationArray = selectedDuration.split(" ");
      let durationInDays = 0;

      if (durationArray?.length === 2) {
        const durationValue = parseInt(durationArray[0]);
        const durationType = durationArray[1];

        if (durationType === "Day" || durationType === "Days") {
          durationInDays = durationValue;
        } else if (durationType === "Week" || durationType === "Weeks") {
          durationInDays = durationValue * 7; // Convert weeks to days
        } else if (durationType === "Month" || durationType === "Months") {
          durationInDays = durationValue * 30; // Assuming 30 days per month
        } else if (durationType === "Year" || durationType === "Years") {
          durationInDays = durationValue * 365; // Assuming 365 days per year
        }
      }

      const currentDate = new Date();
      const nextDate = new Date(
        currentDate.setDate(currentDate.getDate() + durationInDays),
      );
      setNextFollowupDate(nextDate);

      setValue("nextFollowupDate", nextDate);
    }
  }, [selectedChips, setValue]);

  React.useEffect(() => {
    if (selectedChips?.length > 0) {
      let filtered = selectedChips?.filter(
        (c) => c?.toLowerCase() === "no followup",
      );
      if (selectedChips?.length > 0) {
        const selectedDuration = selectedChips[0];
        const durationArray = selectedDuration.split(" ");
        let durationInDays = 0;

        if (durationArray?.length === 2) {
          const durationValue = parseInt(durationArray[0]);
          const durationType = durationArray[1];

          if (durationType === "Day" || durationType === "Days") {
            durationInDays = durationValue;
          } else if (durationType === "Week" || durationType === "Weeks") {
            durationInDays = durationValue * 7; // Convert weeks to days
          } else if (durationType === "Month" || durationType === "Months") {
            durationInDays = durationValue * 30; // Assuming 30 days per month
          } else if (durationType === "Year" || durationType === "Years") {
            durationInDays = durationValue * 365; // Assuming 365 days per year
          }
        }
        const currentDate = new Date();
        const nextDate = new Date(
          currentDate.setDate(currentDate.getDate() + durationInDays),
        );

        if (filtered?.length > 0) {
          setValue("nextFollowupDate", null);
          props?.setIsNoFollowup && props?.setIsNoFollowup(true);
        } else {
          setValue("nextFollowupDate", nextDate);
          props?.setIsNoFollowup && props?.setIsNoFollowup(false);
        }
      }
    }
  }, [selectedChips]);

  useEffect(() => {
    setValue("department", {
      id: patientData?.departmentId,
      label: patientData?.department,
      value: patientData?.departmentId,
    });
    setValue("doctor", {
      id: patientData?.doctorId,
      label: patientData?.doctor,
      value: patientData?.doctorId,
    });
  }, [patientData]);

  return (
    <div>
      <div className="flex justify-between bg-[#E0F0FF] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">Next Follow-up Detail</p>
      </div>
      <div className="p-2 border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        <div className="flex space-x-2 pl-2">
          <div className="flex flex-wrap space-x-2">
            {durationChips &&
              durationChips.map((item, index) => {
                const isSelected = selectedChips.includes(item);
                return (
                  <button
                    type="button"
                    key={index}
                    className={`border border-${
                      isSelected ? "none" : "gray-400"
                    } center relative inline-block select-none whitespace-nowrap rounded-full bg-${
                      isSelected ? "customBlue" : "white"
                    } py-1.5 px-3.5 my-1 align-baseline text-xs  leading-none text-${
                      isSelected ? "white" : "black"
                    }`}
                    onClick={() => {
                      setSelectedChips([item]);
                    }}
                  >
                    {item}
                  </button>
                );
              })}
          </div>
        </div>

        <div className="">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-4 gap-2 items-center my-2">
              <div className=" space-x-2">
                <DatePickerField
                  control={control}
                  // defaultValue={date}
                  name="nextFollowupDate"
                  label="Next Follow-up Date"
                  inputFormat="dd-MM-yyyy"
                  inputRef={{
                    ...register("nextFollowupDate", {
                      onChange: (date) => {
                        console.log(
                          "The date selected for the next followup is :",
                          date?.target?.value,
                        );

                        setSelectedChips([]);
                      },
                    }),
                  }}
                  disablePast
                  // disabled
                />
              </div>
              <div>
                <SearchDropdown
                  control={control}
                  name="department"
                  placeholder="Department"
                  dataArray={departmentOption}
                  menuPlacement="top"
                  handleInputChange={handlechange}
                  isClearable={false}
                  inputRef={{
                    ...register(`department`, {
                      onChange: (e) => {
                        // handleCheckDuplicate();
                        setDepartmentValue(e.target.value);
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <SearchDropdown
                  control={control}
                  name="doctor"
                  placeholder="Doctor"
                  dataArray={doctorOption}
                  menuPlacement="top"
                  handleInputChange={handlechangeDoctor}
                  isClearable={false}
                />
              </div>
              <div className="flex space-x-2">
                <InputField
                  control={control}
                  name="noteFollowup"
                  label="Note"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

